import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

/**
 * Links or unlinks a contract from a delivery note.
 * Pass contractId to link, or null to unlink.
 *
 * @param assetId - The delivery note asset ID.
 * @param contractId - The contract ID to link, or null to unlink.
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/link_contract
 */
export const linkContract = async (
  assetId: UUID,
  contractId: UUID | null,
): Promise<void> => {
  await vestigasApi
    .put(ENDPOINT.DELIVERY_NOTE.LINK_CONTRACT(assetId), {
      json: {
        contractId,
      },
    })
    .json();
};
